import { HttpClient, HttpParameterCodec, HttpParams } from '@angular/common/http';

export class BaseService {
    constructor( protected http: HttpClient ) {
    }

  /**
   * Creates a new `HttpParams` with the correct codec
   */
  protected newParams(): HttpParams {
    return new HttpParams({
      encoder: PARAMETER_CODEC
    });
  }
}

class ParameterCodec implements HttpParameterCodec {
    encodeKey(key: string): string {
      return encodeURIComponent(key);
    }
  
    encodeValue(value: string): string {
      return encodeURIComponent(value);
    }
  
    decodeKey(key: string): string {
      return decodeURIComponent(key);
    }
  
    decodeValue(value: string): string {
      return decodeURIComponent(value);
    }
  }

  const PARAMETER_CODEC = new ParameterCodec();


// WEBPACK FOOTER //
// ./src/app/core/services/BaseService.ts